import SkeletonBase from "./SkeletonBase"
import Card, { CardContent, CardHeader } from "../Card"

/**
 * Skeleton pour QuizPage
 * Reproduit la structure de la page quiz
 */
export default function QuizSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="shadow-lg">
          <CardHeader className="pb-4">
            {/* Quiz title skeleton */}
            <div className="mb-4">
              <SkeletonBase 
                className="h-8 w-3/4 mb-2" 
                width="75%"
                height="2rem"
              />
              <SkeletonBase 
                className="h-5 w-1/2" 
                width="50%"
                height="1.25rem"
              />
            </div>

            {/* Quiz info skeleton */}
            <div className="flex flex-wrap gap-4 mb-4">
              <SkeletonBase 
                className="w-24 h-6 rounded-full" 
                width="6rem"
                height="1.5rem"
                rounded="rounded-full"
              />
              <SkeletonBase 
                className="w-32 h-6 rounded-full" 
                width="8rem"
                height="1.5rem"
                rounded="rounded-full"
              />
              <SkeletonBase 
                className="w-28 h-6 rounded-full" 
                width="7rem"
                height="1.5rem"
                rounded="rounded-full"
              />
            </div>
          </CardHeader>

          <CardContent className="space-y-6">
            {/* Question skeleton */}
            <div className="space-y-4">
              <div className="flex items-center justify-between mb-4">
                <SkeletonBase 
                  className="h-6 w-32" 
                  width="8rem"
                  height="1.5rem"
                />
                <div className="flex gap-2">
                  <SkeletonBase 
                    className="w-16 h-6 rounded-full" 
                    width="4rem"
                    height="1.5rem"
                    rounded="rounded-full"
                  />
                  <SkeletonBase 
                    className="w-16 h-6 rounded-full" 
                    width="4rem"
                    height="1.5rem"
                    rounded="rounded-full"
                  />
                </div>
              </div>

              {/* Question text skeleton */}
              <SkeletonBase 
                className="h-6 w-full mb-2" 
                height="1.5rem"
              />
              <SkeletonBase 
                className="h-6 w-5/6" 
                width="83%"
                height="1.5rem"
              />

              {/* Answers skeleton */}
              <div className="space-y-3 mt-6">
                {[...Array(4)].map((_, i) => (
                  <div 
                    key={i}
                    className="p-4 border-2 border-gray-200 rounded-lg"
                  >
                    <SkeletonBase 
                      className="h-5 w-full" 
                      height="1.25rem"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Navigation buttons skeleton */}
            <div className="flex items-center justify-between pt-6 border-t">
              <SkeletonBase 
                className="w-32 h-10" 
                width="8rem"
                height="2.5rem"
                rounded="rounded-md"
              />
              <SkeletonBase 
                className="w-32 h-10" 
                width="8rem"
                height="2.5rem"
                rounded="rounded-md"
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
